import useSWR from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import IContact from "@/interfaces/contact.interface";
import { IConversationMessages } from "@/interfaces/conversation.interfaces";
import contactService from "@/services/contact.service";
import conversationService from "@/services/conversation.service";

type UseGetConversationReturn = {
  conversationMessages: IConversationMessages | null;
  contact: IContact | null;
  isLoading: boolean;
  error?: Error | null;
};

function useGetConversationMessages(conversationId: number): UseGetConversationReturn {
  const {
    data: conversationMessages,
    isValidating: isMessagesLoading,
    error: messagesError,
  } = useSWR<IConversationMessages, Error>(
    conversationId ? [SWR_KEYS.getConversationMessages, conversationId] : null,
    () => conversationService.getConversationMessages(conversationId!),
    {
      revalidateOnFocus: false,
    }
  );

  const {
    data: contact,
    isValidating: isContactLoading,
    error: contactError,
  } = useSWR<IContact, Error>(
    conversationMessages ? [SWR_KEYS.getContactById, conversationMessages.contactId] : null,
    () => contactService.getById(conversationMessages!.contactId),
    {
      revalidateOnFocus: false,
    }
  );

  return {
    conversationMessages: conversationMessages ?? null,
    contact: contact ?? null,
    isLoading: isMessagesLoading || isContactLoading,
    error: messagesError || contactError,
  };
}

export default useGetConversationMessages;
